
<template>
  <div
    :class="isTransition&&'is-transition'"
    :style="{height:height}"
    class="vue-waterfall"
    id="vueWaterfall"
    ref="vueWaterfall"
  >
    <div class="waterfall-wrapper" ref="waterfallWrapper"></div>
    <div class="slot-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    col: {
      type: Number,
      default: 2
    },
    width: [String, Number],
    height: [String, Number],
    data: {
      type: Array
    },
    isTransition: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {
      root: null,
      columns: [],
      timer: null,
      loadedIndex: 0,
      columnWidth: 0,
      isresizing: false,
      clientHeight: document.documentElement.clientHeight || document.body.clientHeight,
      clientWidth: document.documentElement.clientWidth || document.body.clientWidth,
      spacing: 10,
      line: 1
    }
  },
  watch: {
    col (val) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.init()
        }, 300)
      })
    },
    width (newVal, oldVal) {
      if (newVal) {
        this.width = newVal
        this.clearColumn()
        setTimeout(() => {
          this.init()
        }, 300)
      }
    },
    data (newVal, oldVal) {
      this.$nextTick(() => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.isresizing) {
            return
          }
          if (newVal.length < this.loadedIndex) {
            this.loadedIndex = 0
          }
          if (newVal.length > oldVal.length || newVal.length > this.loadedIndex) {
            if (newVal.length === oldVal.length) {
              this.resize(this.loadedIndex > 0 ? this.loadedIndex : null)
              return
            }
            this.resize(oldVal.length > 0 ? oldVal.length : null)
          }
        }, 300)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    /**
     * 初始化
     */
    init () {
      this.root = this.$refs.waterfallWrapper
      this.clearColumn()
      let col = parseInt(this.col)
      for (let i = 0; i < col; i++) {
        let odiv = document.createElement('div')
        odiv.className = 'vue-waterfall-column'
        if (this.width) {
          this.columnWidth = this.width
          if (this.width * 1 > 0) {
            odiv.style.width = this.columnWidth + 'px'
          } else {
            odiv.style.width = this.columnWidth
          }
        } else {
          odiv.style.width = 100 / parseInt(col) + '%'
          this.columnWidth = 100 / parseInt(col) / 100 * document.documentElement.clientWidth
        }
        if (!this.root) {
          this.root = this.$refs.vueWaterfall
        }
        (odiv => {
          this.root && this.root.appendChild(odiv)
          this.columns.push(odiv)
        })(odiv)
      }
      this.resize()
    },

    /**
     * 格式化
     */
    async resize (index, elements) {
      this.isresizing = true
      if (!this.$slots.default) {
        this.isresizing = false
        return
      }
      if (!index && index !== 0 && !elements) {
        elements = this.$slots.default
        this.loadedIndex = 0
        this.clear()
      } else if (!elements) {
        this.loadedIndex = index
        elements = this.$slots.default.splice(index)
      }
      for (let j = 0; j < elements.length; j++) {
        this.append(elements[j].elm).then(() => {
          this.loadedIndex++
        })
      }
      this.isresizing = false
    },

    /**
     * 追加dom
     */
    async append (dom) {
      if (this.columns.length > 0) {
        let min = this.columns[0]
        // console.log(min, min.offsetHeight)
        let minHeight = min.offsetHeight
        if (minHeight === 0) {
          if (this.line % 2 === 0) {
            min = this.columns[1]
          } else {
            min = this.columns[0]
          }
        }
        this.line++
        for (let i = 1; i < this.columns.length; i++) {
          if (minHeight > this.columns[i].offsetHeight) {
            min = this.columns[i]
          }
        }
        min && min.appendChild(dom)
      }
    },

    computedPx (img, imgApi) {
      img.style.width = imgApi.width / this.columnWidth
    },

    /**
     * 清除dom
     */
    clearColumn () {
      this.columns.forEach((item) => {
        item.remove()
      })
      this.columns = []
    },

    /**
     * 清除dom内容
     */
    clear () {
      this.columns.forEach((item) => {
        item.innerHTML = ''
      })
    },

    /**
     * 随机排序
     */
    mix () {
      let elements = this.$slots.default
      elements.sort(() => { return Math.random() - 0.5 })
      this.resize(0, elements)
    }

  }

}

</script>
<style lang="less">
.vue-waterfall {
  width: 100%;
  // overflow-y: auto;
  position: relative;
  .waterfall-wrapper {
    .flex-between;
    align-items: flex-start;
  }
  .slot-box {
    position: absolute;
    top: 100%;
    left: 100%;
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .is-transition img.animation {
    animation: 0.4s lazy-animation linear;
    animation-fill-mode: forwards;
  }
  .vue-waterfall.is-transition img {
    opacity: 0;
  }
}

@keyframes lazy-animation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
